import request from '@/utils/http.js';
// import env from './env';

// 获取资料库文档列表
const getSharedDocList = (params = {}) => {
  const url = '/v3/interacts/document/get-shared-document-list'
  return request({
    url,
    method: 'GET',
    params: params
  });
};

// 获取当前活动下文档列表
const getWebinarDocList = (params = {}) => {
  const url = '/v3/interacts/document/get-webinar-document-list'
  return request({
    url,
    method: 'POST',
    data: params
  });
};

// 同步文档
const syncDoc = (params = {}) => {
  const url = '/v3/interacts/document/clone-from-shared-document'
  return request({
    url,
    method: 'POST',
    data: params
  });
};

// 删除文档(多选)
const delDocList = (params = {}) => {
  const url = '/v3/interacts/document/batch-remove-reference'

  return request({
    url,
    method: 'POST',
    data: params
  });
};

// 上传文档url
const uploadUrl = '/v3/interacts/document/upload-webinar-document'
export default {
  getSharedDocList,
  getWebinarDocList,
  syncDoc,
  delDocList,
  uploadUrl
};
